import styled from 'styled-components';

export const StyledReductionIcon = styled.svg`
  .icon-bg {
    transition: all 0.3s ease;
    fill: transparent;
    transform-origin: center;
    transform: scale(0.95);
  }

  .icon-path {
    transition: all 0.3s ease;
    fill: #4c4d56;
    transform-origin: center;
  }

  &:hover {
    .icon-bg {
      fill: #e3e5eb;
      transform: scale(1);
    }
  }

  &:active {
    .icon-bg {
      fill: #c1c4ce;
    }
  }
`;
